// extracted by mini-css-extract-plugin
module.exports = {"iconElement":"IconElement__iconElement___1P6wD","thumbnailIcon":"IconElement__thumbnailIcon___E2eaX"};